import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { assign } from 'lodash';
import { Card } from 'src/app/interfaces/card';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CardComponent implements OnInit {
  @Input() cardModel!: Card;
  @Input() enableSelection: boolean = false;
  @Input() hideCheckbox: boolean = false;
  @Output() cardClick = new EventEmitter<Card>();

  // Can pass an isClicked event/value to this component to update it's clicked state.
  @Input() isClicked?: boolean = false;

  getClasses = () => {
    const classArray = [];

    if (this.enableSelection) {
      classArray.push('card-hover');
    }
    if (this.cardModel.isSelected) {
      classArray.push('is-selected');
    }
    if (!this.cardModel.style) {
      classArray.push('py-2');
    }

    if (this.cardModel.classes) {
      // Isn't necessary to split then push.
      classArray.push(...this.cardModel.classes.split(' '));
    }

    return classArray.join(' ');
  };

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(SimpleChanges: SimpleChanges): void {
    const { isClicked } = SimpleChanges;
    if (isClicked) {
      const { currentValue } = isClicked;
      if (currentValue !== undefined) {
        this.cardClicked();
      }
    }
  }

  cardClicked() {
    if (!this.cardModel.preventSelection) {
      assign(this.cardModel, { isSelected: !this.cardModel.isSelected });
      this.cardClick.emit(this.cardModel);
    }
  }
}
